import { INITIATOR } from "modules/BookingCommon/components/DatePicker/constants"
import { ServicesGroup } from "utils/helpers/ServicesGroup"

export function getCardName(serviceGroup: ServicesGroup, initiator: INITIATOR) {
    if (initiator === INITIATOR.PSYCHOLOGIST && serviceGroup.id === 1) {
        return "Индивидуально"
    }
    return serviceGroup.name
}
